import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { IPlaque } from '../../interfaces/plaque.interface';
import { HttpHeaders } from '@angular/common/http';
import { IDictionary } from '../../interfaces/common.interfaces';


@Injectable({
  providedIn: 'root'
})
export class PlaquesService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  getAvailablePlaques(
    communityId: number,
    request: IPagingRequestModel,
  ): Observable<PagedResult<IPlaque>> {
    const url = `PlaqueAvailable/list/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

      const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: request, 
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: PagedResult<IPlaque>) => response)
    );
  }

  getPlaquesDataForFilters(
    communityId: number,
    isAvailablePlaques : string
  ): Observable<IDictionary<string, string[]>> {
    const url = `plaquesfilter/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};
    params['isAvailablePlaques'] = isAvailablePlaques;

      const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        params : params 
      };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: IDictionary<string, string[]>) => response)
    );
  }
  exportAvailableFilteredDataToCsv(communityId: number,  filters: { [key: string]: string[] }): Observable<Blob> {
    const url = `plaqueavailable/export/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

      const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: filters, 
        responseType: 'blob'
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: Blob) => response)
    );
  }
  getInUsePlaques(
    communityId: number,
    request: IPagingRequestModel,
  ): Observable<PagedResult<IPlaque>> {
    const url = `PlaquesInUse/list/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

      const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: request, 
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: PagedResult<IPlaque>) => response)
    );
  }
  exportInUseFilteredDataToCsv(communityId: number,  filters: { [key: string]: string[] }): Observable<Blob> {
    const url = `PlaquesInUse/export/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

      const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: filters, 
        responseType: 'blob'
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: Blob) => response)
    );
  }
  plaqueQRCodeDownload(plaqueId: number): Observable<string> {
    let url = `plaque/qrcode/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      responseType: 'text', 
    };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: string) => response)); 
  }
}